<script lang="ts" setup>
defineOptions({
  inheritAttrs: false,
});

const { isFrozenProduct, isVariableWeight } = defineProps<{
  isFrozenProduct?: boolean | null | undefined;
  isLimited?: boolean | null | undefined;
  isNew?: boolean | null | undefined;
  isSale?: boolean | null | undefined;
  isVariableWeight?: boolean | null | undefined;
  show: { iconLabel: boolean; zoom: boolean };
}>();

const { t } = useI18n();

const icons = computed(() => {
  const iconList = [];

  if (isVariableWeight) {
    iconList.push({ iconName: "i-ph-scales", iconLabel: t("product.icon.variable-weight"), bgColor: "bg-[#F3F1EC]" });
  }

  if (isFrozenProduct) {
    iconList.push({ iconName: "i-ph-snowflake", iconLabel: t("product.icon.frozen-product"), bgColor: "bg-[#CBE8FC]" });
  }

  return iconList;
});
</script>

<template>
  <div class="relative flex items-center justify-center" :class="($attrs.class as any)">
    <div class="top-md absolute left-0 z-10">
      <ProductBadge v-if="isLimited" badge-type="limited" />
      <ProductBadge v-else-if="isNew" badge-type="new" />
      <ProductBadge v-else-if="isSale" badge-type="sale" />
    </div>

    <div v-if="show.zoom" class="left-xl gap-xs absolute bottom-[85px] z-10 flex items-center lg:bottom-[125px]">
      <UIcon name="i-ph-magnifying-glass-plus" />
      <span class="text-sm font-medium">{{ t("product.action.image-zoom") }}</span>
    </div>

    <div v-if="icons.length" class="right-sm top-sm absolute z-10">
      <div class="gap-xs flex flex-col">
        <div
          v-for="icon of icons" :key="icon.iconName"
          class="gap-xs flex items-center rounded-full"
          :class="[{ 'px-xs h-8': show.iconLabel, 'size-8 justify-center': !show.iconLabel }, icon.bgColor]"
        >
          <span v-if="show.iconLabel" class="hidden text-sm font-medium lg:inline-flex">{{ icon.iconLabel }}</span>
          <UIcon :name="icon.iconName" class="text-xl" />
        </div>
      </div>
    </div>

    <slot />
  </div>
</template>

<style scoped>

</style>
